import script from "./savings.vue?vue&type=script&setup=true&lang=js"
export * from "./savings.vue?vue&type=script&setup=true&lang=js"

import "./savings.vue?vue&type=style&index=0&id=469ee73f&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-469ee73f"]])

export default __exports__